import {Field, useFormikContext} from "formik";
import React from "react";
import store from "@formApp/store"

export default ({condition, name, defaultValue, label, children}) => {
  const {
    values: { entity },
    touched,
    setFieldValue,
  } = useFormikContext();
  const [isFocus, setFocus] = React.useState(false);
  const [isVisible, setVisible] = React.useState(false);
  const {formValues} = React.useContext(store);
  React.useEffect(() => {
    if (!Array.isArray(condition)) condition = [condition];
    setVisible(condition.indexOf(entity) >= 0);
    setFieldValue(name, formValues.getValue(name) || defaultValue);
  }, [entity]);
  return (
    <>
    {isVisible &&
    <Field name={name}>
      {({field, meta: {touched, error, value}}) => {
        const toggleFocus = e => {
          if (isFocus) field.onBlur(e);
          setFocus(!isFocus);
        };
        return (
          <div className={`formGroup${(touched && error) ? ' error' : ''}`}>
            {label && <label className={`fieldLabel${(value || isFocus) ? ' touched' : ''}`}>{label}</label>}
            {(children)
              ? children(field, toggleFocus)
              : <input className='formField' type="text" {...field} onFocus={toggleFocus} onBlur={toggleFocus} />
            }
            {touched && error && <div className="errorMessage">{error}</div>}
          </div>
        )
      }}
    </Field>
    }
    </>
  )
}